<table>

  <thead>
    <tr>
      <th>Dossier</th>
      <th style="width: 110px">Date d'ajout</th>
      <th style="width: 64px;"></th>
    </tr>
  </thead>

  <tbody *ngIf="dossiers && dossiers.length > 0">
    <tr *ngFor="let dossier of dossiers" (click)="onSelect(dossier)">
      <td name="Dossier">
        {{ dossier.name }}
      </td>
      <td name="Date d'ajout" style="width: 110px">
        {{ dossier.created_at | tzdate:'short' }}
      </td>
      <td style="width: 64px;" class="actions">
        <a class="action-btn" *ngIf="selectedDossier && dossier.id === selectedDossier.id">
          <t-icon name="check"></t-icon>
        </a>
      </td>
    </tr>
  </tbody>

  <tbody *ngIf="!dossiers || dossiers.length == 0">
    <tr>
      <td class="text-center" colspan="3">
        <ng-container *ngIf="dossiers && dossiers.length == 0">
          Aucun dossier n'a été trouvé
        </ng-container>
        <ng-container *ngIf="!dossiers">
          Chargement...
        </ng-container>
      </td>
    </tr>
  </tbody>

</table>

<div class="pagination" *ngIf="dossiers">
  <button class="btn btn-gray" (click)="fetchMore()" *ngIf="dossiers.length < dossiersCount">
    <t-icon name="arrow_downward"></t-icon>
    <span class="text">Afficher plus</span>
  </button>
  <div class="page-number">
    {{ dossiers.length }} / {{ dossiersCount }}
  </div>
</div>